class JobAssignedEmployeeUpdate  {
  id: string
  order: number

  constructor(jobAssignedEmployeeUpdate?: any) {
    this.id = jobAssignedEmployeeUpdate?.id
    this.order = jobAssignedEmployeeUpdate?.order ?? -1
  }
}

export default JobAssignedEmployeeUpdate
